module.exports = __webpack_public_path__ + "img/wohnst-du-jetzt-im-himmel.42bbf0c8.jpg";